import React, {
  useCallback,
  useEffect,
  useReducer,
  useRef,
  useState
} from 'react'
import { useTranslation } from 'react-i18next'
import {
  useAccount,
  useSignMessage,
  useSwitchChain,
  useWaitForTransactionReceipt,
  useWriteContract
} from 'wagmi'
// import { Interface } from 'ethers'

import { vestingAbi } from '../abis/vestingAbi'
import CommunitySale from '../components/communitySale/CommunitySale'
import ClaimPopup from '../components/popups/ClaimPopup'
import SuccessPopup from '../components/popups/SuccessPopup'
import Loading from '../components/shared/loading/Loading'
import {
  // CURRENCIES,
  CLAIM_CURRENCY_TYPE,
  REFRESH_AVAILABLE_BALANCE_INTERNAL
} from '../constants/app'
import {
  CLAIM_PROCESS_STEP,
  DEFAULT_CONTAINER_STATE
} from '../constants/containerStates'
import { SUCCESS_POPUP_TYPE } from '../constants/popup'
import { changeMainState, resetMainState } from '../store/actions/main'
import {
  MAIN_PROFILE_DISPATCH,
  mainInitialState,
  mainReducer
} from '../store/reducers/main'
import {
  buildContractsByAvailability,
  buildReadFromStakingContract,
  calculateAvailableBalance,
  filterAvailableBalanceById,
  filterContractsForCalculation,
  qbxToVir,
  stakingContractConfig,
  stakingContractConfig2
} from '../util/claim.helpers'
import { mergeUniqueList } from '../util/object.helpers'
import {
  buildTransactionErrorMessage,
  checkWalletConnected
} from '../util/walletConnect.helpers'
// import { formatTicks } from '../util/string.helpers'
// import { formatAmount, formatCurrencyValue } from '../util/numbers.helpers'
import { tapAbi } from '../abis/tapAbi'
import ClaimTapPopup from '../components/popups/ClaimTapPopup'
import { getChain } from '../components/walletConnect/wagmiConfig'
import {
  claimStakingAPI,
  customVestClaimAPI,
  getStakingDataAPI
} from '../util/api.helpers'
// import { stakingAbi } from '../abis/stakingAbi'
import { isCustomVestingFlow } from '../util/app.helpers'

const chainId = getChain().id

const CommunitySaleContainer = () => {
  const [mainProfile, dispatch] = useReducer(mainReducer, mainInitialState)

  const [popupState, setPopupState] = useState({
    id: DEFAULT_CONTAINER_STATE.NONE,
    data: null
  })

  const [claimType, setClaimType] = useState('')

  const availableBalanceTimer = useRef(null)

  const { address, status } = useAccount()
  const { switchChain } = useSwitchChain()

  const isWalletConnected = checkWalletConnected({ address, status })
  const { t } = useTranslation()

  const {
    data: claimFundsHash,
    isPending: isClaimFundsPending,
    error: claimFundsErr,
    writeContract: claimFundsWrite
  } = useWriteContract()

  const {
    isLoading: isClaimFundsProcessing,
    isSuccess: isClaimFundsConfirmed
    // data: transactionReceiptData
  } = useWaitForTransactionReceipt({
    hash: claimFundsHash
  })

  const {
    data: claimStakeHash,
    isPending: isClaimStakePending,
    error: claimStakeErr,
    writeContract: claimStakeWrite
  } = useWriteContract()

  const {
    isLoading: isClaimStakeProcessing,
    isSuccess: isClaimStakeConfirmed
    // data: transactionClaimStakeReceiptData
  } = useWaitForTransactionReceipt({
    hash: claimStakeHash
  })

  useEffect(() => {
    if (isClaimStakeConfirmed) {
      // const iface = new Interface(stakingAbi)
      // let claimedAmount = 0
      // try {
      //   const parsedLog = iface.parseLog(
      //     transactionClaimStakeReceiptData.logs[0]
      //   )
      //   claimedAmount = formatCurrencyValue(formatAmount(parsedLog.args[1]))
      // } catch (e) {
      //   console.log(e)
      // }
      dispatchAction(MAIN_PROFILE_DISPATCH.ERROR, {})
      setPopupState({
        id: CLAIM_PROCESS_STEP.SUCCESS,
        data: {
          type: SUCCESS_POPUP_TYPE.CLAIMED_QBX
          // value: `${formatTicks(claimedAmount)} ${CURRENCIES.DEFAULT}`
        }
      })
      getStakingContractData()
    }
  }, [isClaimStakeConfirmed])

  useEffect(() => {
    if (claimStakeErr) {
      updateError({
        claimStake: buildTransactionErrorMessage(claimStakeErr.shortMessage)
      })
    }
  }, [claimStakeErr])

  const updateClaimStakeProcessing = (isProcessing) => {
    dispatchAction(MAIN_PROFILE_DISPATCH.CLAIM_STAKE_PROCESSING, isProcessing)
  }

  useEffect(() => {
    if (isClaimStakeProcessing || isClaimStakePending) {
      updateClaimStakeProcessing(true)
    }
  }, [isClaimStakeProcessing, isClaimStakePending])

  const handleClaimStake = () => {
    switchChain({ chainId })
    updateClaimStakeProcessing(true)
    claimStakeWrite({
      ...stakingContractConfig(),
      functionName: 'claim',
      args: []
    })
  }

  const handleClaimStake2 = () => {
    setClaimType(CLAIM_CURRENCY_TYPE.QBX)
    dispatchAction(MAIN_PROFILE_DISPATCH.CLAIM_STAKE_PROCESSING2, true)
    signMessage({ message: CLAIM_CURRENCY_TYPE.QBX })
  }

  const {
    signMessage,
    error: signMsgErr,
    data: signMsgData,
    isPending: signMsgPending
  } = useSignMessage()

  useEffect(() => {
    if (signMsgPending) {
      if (popupState.id === CLAIM_PROCESS_STEP.CLAIM_TAP) {
        dispatchAction(MAIN_PROFILE_DISPATCH.CLAIM_TAP_PROCESSING, true)
      } else {
        dispatchAction(MAIN_PROFILE_DISPATCH.CLAIM_STAKE_PROCESSING2, true)
      }
    }
  }, [signMsgPending])

  useEffect(() => {
    if (signMsgErr) {
      if (popupState.id === CLAIM_PROCESS_STEP.CLAIM_TAP) {
        updateError({
          claimTap: buildTransactionErrorMessage(signMsgErr.shortMessage)
        })
      } else {
        updateError({
          claimStake2: buildTransactionErrorMessage(signMsgErr.shortMessage)
        })
      }
    }
  }, [signMsgErr])

  useEffect(() => {
    if (signMsgData) {
      if (popupState.id === CLAIM_PROCESS_STEP.CLAIM_TAP) {
        customVestClaimAPI(
          dispatch,
          address,
          claimType,
          signMsgData,
          popupState?.data?.id
        )
      } else {
        claimStakingAPI(dispatch, address, signMsgData)
      }
    }
  }, [signMsgData])

  useEffect(() => {
    if (mainProfile.claimedVir) {
      setPopupState({
        id: CLAIM_PROCESS_STEP.SUCCESS,
        data: {
          type: SUCCESS_POPUP_TYPE.CLAIMED_VIR,
          value: qbxToVir(mainProfile.claimedVir?.releaseable)
        }
      })
    }
  }, [mainProfile.claimedVir])

  useEffect(() => {
    if (mainProfile.qbxTxnPayload?.releaseable) {
      const { nonce, signedData, releaseable } = mainProfile.qbxTxnPayload
      if (signedData && releaseable) {
        switchChain({ chainId })
        updateTxnProcessing(true)
        const address =
          popupState && popupState?.data?.address
            ? popupState.data.address
            : stakingContractConfig2()?.address
        // @TODO: test this for quest vesting and staking contract cases
        claimFundsWrite({
          address: address,
          abi: tapAbi,
          functionName: 'transferTokens',
          args: [releaseable, nonce, signedData]
        })
      }
    }
  }, [mainProfile.qbxTxnPayload])

  const handleClaimTap = (type) => {
    setClaimType(type)
    dispatchAction(MAIN_PROFILE_DISPATCH.CLAIM_TAP_PROCESSING, true)
    signMessage({ message: type })
  }

  useEffect(() => {
    if (isWalletConnected) {
      syncContractsForClaim()
      getStakingContractData()
      getStakingAPIData()
    }
  }, [isWalletConnected])

  useEffect(() => {
    if (isClaimFundsConfirmed) {
      const isClaimType = claimType === CLAIM_CURRENCY_TYPE.QBX
      // const iface = new Interface(isClaimType ? tapAbi : vestingAbi)
      // let claimedAmount = 0
      const isPopup = popupState?.id
      try {
        if (isClaimType) {
          // if (transactionReceiptData?.logs?.length) {
          //   claimedAmount = formatCurrencyValue(
          //     formatAmount(Number(transactionReceiptData.logs[0].data))
          //   )
          // }
          if (!isPopup) {
            getStakingAPIData()
          }
        } else {
          // const parsedLog = iface.parseLog(transactionReceiptData?.logs[0])
          // claimedAmount = formatCurrencyValue(formatAmount(parsedLog.args[1]))
        }
      } catch (e) {
        console.log(e)
      }
      dispatchAction(MAIN_PROFILE_DISPATCH.ERROR, {})
      setPopupState({
        id: CLAIM_PROCESS_STEP.SUCCESS,
        data: {
          type: SUCCESS_POPUP_TYPE.CLAIMED_QBX
          // value: `${formatTicks(claimedAmount)} ${CURRENCIES.DEFAULT}`
        }
      })
      if (isPopup) {
        syncContractsForClaim()
      }
    }
  }, [isClaimFundsConfirmed])

  useEffect(() => {
    startBalanceInterval()
    return () => {
      clearBalanceInterval()
    }
  }, [isWalletConnected, mainProfile.contractsForClaim])

  useEffect(() => {
    if (mainProfile.claimQBXProcessing) {
      clearBalanceInterval()
    } else {
      startBalanceInterval()
    }
  }, [mainProfile.claimQBXProcessing])

  useEffect(() => {
    if (claimFundsErr) {
      updateError({
        claimQBX: buildTransactionErrorMessage(claimFundsErr.shortMessage)
      })
    }
  }, [claimFundsErr])

  useEffect(() => {
    if (isClaimFundsProcessing || isClaimFundsPending) {
      updateTxnProcessing(true)
    }
  }, [isClaimFundsProcessing, isClaimFundsPending])

  const startBalanceInterval = () => {
    if (isWalletConnected && mainProfile.contractsForClaim.length) {
      const filteredContracts = filterContractsForCalculation(
        mainProfile.contractsForClaim
      )
      if (filteredContracts.length) {
        availableBalanceTimer.current = setInterval(() => {
          dispatchAction(
            MAIN_PROFILE_DISPATCH.CONTRACTS_TO_CLAIM,
            mergeUniqueList(
              mainProfile.contractsForClaim,
              calculateAvailableBalance(filteredContracts),
              'id'
            )
          )
        }, REFRESH_AVAILABLE_BALANCE_INTERNAL)
      } else {
        clearBalanceInterval()
      }
    }
  }

  const clearBalanceInterval = () => {
    clearInterval(availableBalanceTimer.current)
  }

  const updateError = (error) => {
    dispatchAction(MAIN_PROFILE_DISPATCH.ERROR, error)
  }

  const updateTxnProcessing = (isProcessing) => {
    dispatchAction(MAIN_PROFILE_DISPATCH.CLAIM_QBX_PROCESSING, isProcessing)
  }

  const handleNoPopup = () => {
    setPopupState({ id: DEFAULT_CONTAINER_STATE.NONE, data: popupState.data })
    dispatch(resetMainState())
  }

  const syncContractsForClaim = () => {
    dispatchAction(MAIN_PROFILE_DISPATCH.LOADING, true)
    Promise.all(
      buildContractsByAvailability(
        address,
        mainProfile.contractsForClaim.map(({ id }) => id)
      )
    )
      .then((data) => {
        dispatchAction(
          MAIN_PROFILE_DISPATCH.CONTRACTS_TO_CLAIM,
          calculateAvailableBalance(data.filter(({ total }) => total > 0))
        )
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => {
        dispatchAction(MAIN_PROFILE_DISPATCH.LOADING, false)
      })
  }

  const getStakingContractData = () => {
    dispatchAction(MAIN_PROFILE_DISPATCH.CLAIM_STAKE, {
      ...mainProfile.claimStake,
      loading: true
    })
    Promise.resolve(buildReadFromStakingContract(address))
      .then((data) => {
        const { available } = data
        dispatchAction(MAIN_PROFILE_DISPATCH.CLAIM_STAKE, {
          ...mainProfile.claimStake,
          available,
          loading: false
        })
      })
      .catch((error) => {
        console.error(error)
        dispatchAction(MAIN_PROFILE_DISPATCH.CLAIM_STAKE, {
          ...mainProfile.claimStake,
          loading: false
        })
      })
  }

  const getStakingAPIData = () => {
    getStakingDataAPI(dispatch, address)
  }

  const handleOnClickClaim = useCallback((option) => {
    setClaimType('')
    if (isCustomVestingFlow(option.id)) {
      setPopupState({ id: CLAIM_PROCESS_STEP.CLAIM_TAP, data: option })
    } else {
      setPopupState({ id: CLAIM_PROCESS_STEP.CLAIM, data: option })
    }
  }, [])

  const dispatchAction = (attr, value) => {
    dispatch(changeMainState(attr, value))
  }

  const handleOnSubmitPopup = () => {
    switch (popupState.id) {
      case CLAIM_PROCESS_STEP.CLAIM:
        switchChain({ chainId })
        updateTxnProcessing(true)
        claimFundsWrite({
          address: popupState.data.address,
          abi: vestingAbi,
          functionName: 'release',
          args: []
        })
        break

      default:
        handleNoPopup()
        break
    }
  }

  const handleOnCancelPopup = () => {
    switch (popupState.id) {
      case CLAIM_PROCESS_STEP.CLAIM_TAP:
        setClaimType('')
        handleNoPopup()
        break

      default:
        handleNoPopup()
    }
  }

  const renderPopup = () => {
    switch (popupState.id) {
      // case CLAIM_PROCESS_STEP.CLAIM_STAKING:
      //   return (
      //     <ConnectAccountPopup
      //       t={t}
      //       onClose={handleOnCancelPopup}
      //       onSubmit={handleOnSubmitPopup}
      //       mainProfile={mainProfile}
      //       dispatchAction={dispatchAction}
      //     />
      //   )

      case CLAIM_PROCESS_STEP.CLAIM:
        return (
          <ClaimPopup
            t={t}
            onClose={handleOnCancelPopup}
            onSubmit={handleOnSubmitPopup}
            available={filterAvailableBalanceById(
              mainProfile.contractsForClaim,
              popupState.data.id
            )}
            mainProfile={mainProfile}
            dispatchAction={dispatchAction}
          />
        )

      case CLAIM_PROCESS_STEP.CLAIM_TAP:
        return (
          <ClaimTapPopup
            t={t}
            onClose={handleOnCancelPopup}
            available={filterAvailableBalanceById(
              mainProfile.contractsForClaim,
              popupState.data.id
            )}
            mainProfile={mainProfile}
            dispatchAction={dispatchAction}
            onClaimTap={handleClaimTap}
            {...popupState?.data}
          />
        )

      case CLAIM_PROCESS_STEP.SUCCESS:
        return (
          <SuccessPopup
            t={t}
            onSubmit={handleOnSubmitPopup}
            {...popupState?.data}
          />
        )

      default:
        break
    }
  }

  return mainProfile.loading ||
    ['connecting', 'reconnecting'].includes(status) ? (
    <Loading />
  ) : (
    <>
      <CommunitySale
        t={t}
        mainProfile={mainProfile}
        isWalletConnected={isWalletConnected}
        onClickClaim={handleOnClickClaim}
        claimStakeProps={{
          onClaimStake: handleClaimStake,
          onClaimStake2: handleClaimStake2,
          dispatchAction,
          isPopupOpened: popupState?.id
        }}
        address={address}
      />
      {renderPopup()}
    </>
  )
}

export default CommunitySaleContainer
